import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { OSMResponse, PortalServiceInterface } from './portal.service.interface';
import { environment } from '../../../environments/environment';
import { OSM_RESPONSE_MOCK } from './mock';

@Injectable({
  providedIn: 'root',
})
export class PortalService implements PortalServiceInterface {
  private http = inject(HttpClient);

  uploadOSMFile(file: File): Observable<OSMResponse> {
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();

    if (!fileExtension || (fileExtension !== 'xml' && fileExtension !== 'zip')) {
      throw new Error($localize`Unsupported file type`);
    }

    const headers = new HttpHeaders({
      'Content-Type': `application/${fileExtension}`,
    });

    return this.http.post<OSMResponse>(environment.portal.osm, file, { headers });
  }

  exampleOSMFile(): Observable<OSMResponse> {
    return of(OSM_RESPONSE_MOCK);
  }

  downloadOSMFile(file: File): Observable<Blob> {
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();

    if (!fileExtension || (fileExtension !== 'xml' && fileExtension !== 'zip')) {
      throw new Error('Unsupported file type');
    }

    const headers = new HttpHeaders({
      'Content-Type': `application/${fileExtension}`,
      Accept: `application/zip`,
    });

    return this.http.post<Blob>(environment.portal.osm, file, { headers, responseType: 'blob' as 'json' });
  }

  downloadExampleOSMFile(): Observable<Blob> {
    return this.http.get('/osm/osm.zip', { responseType: 'blob' });
  }

  getExampleHeatmapData(): Observable<OSMResponse> {
    return this.http
      .get<{ Filename: string; latitude: number; longitude: number }[]>('wild-oats-mapping/data.json')
      .pipe(
        map((data) => {
          const points = data.map((point) => ({
            geometry: {
              type: 'HeatPoint' as const,
              coordinates: [point.longitude, point.latitude] as [number, number],
            },
            properties: { designator: null, type: 'Heat' as const },
            id: point.Filename,
          }));
          return { features: points };
        }),
      );
  }
}
